/*
 * @Author: your name
 * @Date: 2020-05-05 16:37:39
 * @LastEditTime: 2020-05-20 22:38:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue-basic-ui/packages/table/index.js
 */
import zyTable from './src/table.vue'

zyTable.install = Vue => {
  Vue.component(zyTable.name, zyTable)
}

export default zyTable



//////////////////
// WEBPACK FOOTER
// ./packages/table/index.js
// module id = null
// module chunks = 